import Navbar from './Common/Navbar'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Product from './Componant/Product';
import Cart from './Componant/Cart'

function App() {
  return (
    <>
      <Router>
      <Navbar/>
        <Routes>
          <Route path='/' element={<Product/>}/>
          <Route path='/cart' element={<Cart />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
